import React from "react";
import moment from "moment";

/**
 * Convierte los datos del formulario en un objeto de carga útil para la API.
 * Se utilizó el formato utilizado para recepciones individuales.
 * @param {Object} formData - Datos del formulario.
 * @returns {Object} Objeto de carga útil.
 */
export const formToPayload = (formData) => {
    let payload = {};
    // datos compartidos
    const hora24hrs = moment(formData.hora_ingreso, "hh:mm a").format("HH:mm");
    const fecha = moment(formData.fecha || moment()).format('YYYY-MM-DD');

    payload.fecha = `${fecha} ${hora24hrs}`;
    payload.fecha_analisis = fecha;

    payload.hora_ingreso = hora24hrs;
    payload.hora_analisis = hora24hrs;

    payload.piloto = formData.piloto.value;
    payload.vehiculo = formData.vehiculo.value;

    // datos de contenedores
    payload.contenedores = formData.contenedores.map((contenedor, index) => {
        return {
            finca: contenedor.finca.value,
            tipo_materia: contenedor.tipo_materia_prima.value,
            peso_bruto: contenedor.peso_bruto_ingreso ? parseFloat(contenedor.peso_bruto_ingreso) : 0,
            productos: contenedor.productos.map((producto) => {
                const unidad = producto.unidad.value;
                const pesoFinca = producto.peso_finca ? parseFloat(producto.peso_finca) : 0;
                const pesoFincaKg = pesoFinca * unidad;

                return {
                    destino: "Indefinido",
                    index: index,
                    materia_prima: producto.materia_prima.value,
                    peso_finca: pesoFinca,
                    peso_finca_kg: pesoFincaKg,
                    peso_finca_unidad: unidad,
                }
            })
        }
    });

    return payload;
}

export const restringirPesajeIngreso = (item = {}) => {
    if (!item) return false;
    // si es un ingreso compartido y no tiene peso de ingreso
    // es porque falta pesar la recepción anterior
    return item.viaje_ingreso && !item.peso_ingreso
}
